import Block from '../../../../_base/src/components/block/index'

export default class HarmonicGallery extends Block {
	static title = 'block-gallery'

	constructor($el) {
		super($el)

		if (this.$el.hasModifier('carousel')) {
			$(document).on('sl-slide-change', () => {
				this.updateNextSlide()
			})
		}
	}

	updateNextSlide() {
		this.$el.find('sl-carousel-item').removeClass('--next-in-view')

		this.$el
			.find('sl-carousel-item.--is-active')
			.nextAll('sl-carousel-item')
			.first()
			.addClass('--next-in-view')
	}
}
